const Error = () => {
  return <div>
    <h2>404</h2>
    <p>Stránka nenalezena</p>
  </div>
}

export default Error